export default __webpack_public_path__ + "static/media/smart-airfield-solution-1.68f4b8f7.jpg";